module.exports = __webpack_public_path__ + "img/grid-view-active.525dbffe.svg";